module.exports = __webpack_public_path__ + "img/discord.facf061f.svg";